// src/components/Login.js
import React, { useContext, useEffect, useState } from "react";
import useAxios from "../../common/hook/useAxios";
import { AuthContext } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const Login = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    practiceId: "",
    username: "",
    password: "",
  });
  const [errors, setErrors] = useState({});
  const { request } = useAxios();
  const { login, user } = useContext(AuthContext);

  // useEffect(() => {
  //   if (user) {
  //     navigate("/");
  //   }
  // }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.practiceId) newErrors.practiceId = "Practice ID is required";
    if (!formData.username) newErrors.username = "Username is required";
    if (!formData.password) newErrors.password = "Password is required";
    return newErrors;
  };

  const fetchToken = async (
    UserName,
    PracticeId,
    token,
    DefaultTimeZoneOffSet,
    userId,
    practiceFullId,
    userFullName,
    practiceName
  ) => {
    const requestBody = {
      UserName,
      PracticeId,
    };
    try {
      const data = await request(
        `${process.env.REACT_APP_LOGIN_API_URL}/authentication/GetAuthToken?sInputJSON=${JSON.stringify(requestBody)}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },

          method: "GET",
        },
      );
      const newData = {
        ...data,
        DefaultTimeZoneOffSet,
        userId,
        practiceFullId,
        userFullName,
        practiceName
      };
      login(JSON.stringify(newData));
    } catch (error) {
      console.log(error);
      toast.error("Failed to fetch token", { autoClose: 3000 });
      return;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    const requestBody = {
      UserName: formData.username,
      PracticeId: formData.practiceId,
      Password: formData.password,
      isMobileLogin: false,
      RoleID: 4,
    };
    try {
      const data = await request(
        `${process.env.REACT_APP_LOGIN_API_URL}/Authentication/Authenticate?sInputJSON=${JSON.stringify(requestBody)}`,
        {
          method: "GET",
        },
      );
if(data!=undefined)
     { toast.success("Login Successful", { autoClose: 2000 });
      await fetchToken(
        requestBody?.UserName,
        data?.practiceID,
        data?.sAuthToken,
        data?.DefaultTimeZoneOffSet,
        data?.userID,
        data?.practiceFullID,
        data?.userFullName,
        data?.practiceName
      );
      await navigate("/");
     }
     else{
      toast.error("Invalid credentials", { autoClose: 6000 });
     }
    } catch (err) {
      toast.error("Error occurred while logging in", { autoClose: 3000 });
    }
  
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="w-full max-w-md p-8 bg-white rounded-lg shadow-md">
        <h2 className="text-2xl font-bold mb-6 text-center">Login</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label
              htmlFor="practiceId"
              className="block text-sm font-medium text-gray-700"
            >
              Practice ID
            </label>
            <input
              type="text"
              id="practiceId"
              name="practiceId"
              value={formData.practiceId}
              onChange={handleChange}
              className={`mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm ${errors.practiceId ? "border-red-500" : ""}`}
            />
            {errors.practiceId && (
              <p className="text-red-500 text-sm mt-1">{errors.practiceId}</p>
            )}
          </div>
          <div className="mb-4">
            <label
              htmlFor="username"
              className="block text-sm font-medium text-gray-700"
            >
              Username
            </label>
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              className={`mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm ${errors.username ? "border-red-500" : ""}`}
            />
            {errors.username && (
              <p className="text-red-500 text-sm mt-1">{errors.username}</p>
            )}
          </div>
          <div className="mb-6">
            <label
              htmlFor="password"
              className="block text-sm font-medium text-gray-700"
            >
              Password
            </label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              className={`mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm ${errors.password ? "border-red-500" : ""}`}
            />
            {errors.password && (
              <p className="text-red-500 text-sm mt-1">{errors.password}</p>
            )}
          </div>
          <button
            type="submit"
            className="w-full py-2 px-4 bg-blue-500 text-white font-semibold rounded-lg shadow-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
          >
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
